/* BLINK configured purchase, v1. Native nested lines + explicit manufacturing properties. */
(function () {
  'use strict';
  const parse = (value, fallback) => { try { return JSON.parse(value); } catch (_) { return fallback; } };
  const props = line => line.properties || {};
  const NAME_VARIANT_ID = 50554903232591;
  const isNameEngraving = line => Number(line.variant_id || line.id) === NAME_VARIANT_ID;
  const validEngraving = value => /^[A-Za-z]{1,10}$/.test(String(value || ''));

  function groupCart(cart) {
    const items = cart.items || [];
    return items.filter(line => props(line)._blink_role !== 'option').map(parent => ({
      parent,
      children: props(parent)._blink_role === 'case' ? items.filter(line =>
        props(line)._blink_role === 'option' && props(line)._blink_config === props(parent)._blink_config) : []
    }));
  }
  function checkGroup(group) {
    const parent = group.parent;
    if (props(parent)._blink_role !== 'case') return !isNameEngraving(parent);
    const engraving = props(parent)['名入れ刻印'] || '';
    const engravingLines = group.children.filter(isNameEngraving);
    if (engraving ? !validEngraving(engraving) || engravingLines.length !== 1 : engravingLines.length !== 0) return false;
    const expected = parse(props(parent)._blink_manifest, null);
    if (!Array.isArray(expected) || group.children.length !== expected.length) return false;
    return expected.every(expectedLine => {
      const matches = group.children.filter(line => Number(line.variant_id || line.id) === Number(expectedLine.id));
      return matches.length === 1 && matches[0].quantity === parent.quantity * expectedLine.quantity &&
        matches[0].parent_relationship?.parent_key === parent.key;
    });
  }
  function checkCart(cart) {
    const groups = groupCart(cart);
    return groups.every(group => checkGroup(group) && (!props(group.parent)._blink_replaces ||
      !groups.some(other => props(other.parent)._blink_config === props(group.parent)._blink_replaces))) && (cart.items || []).every(line => props(line)._blink_role !== 'option' ||
      groups.some(group => group.children.includes(line)));
  }
  function quantityUpdates(group, quantity) {
    if (!Number.isSafeInteger(quantity) || quantity < 0 || quantity > 99) throw new Error('数量を1〜99で指定してください。');
    const updates = { [group.parent.key]: quantity };
    const manifest = parse(props(group.parent)._blink_manifest, []);
    group.children.forEach(line => {
      const entry = manifest.find(item => Number(item.id) === Number(line.variant_id || line.id));
      if (!entry) throw new Error('オプションの構成を確認できません。仕様を変更して入れ直してください。');
      updates[line.key] = quantity * entry.quantity;
    });
    return updates;
  }
  if (typeof module !== 'undefined' && module.exports) module.exports = { groupCart, checkGroup, checkCart, quantityUpdates, validEngraving };
  if (typeof document === 'undefined') return;
  const dataNode = document.getElementById('blink-purchase-data');
  if (!dataNode || document.documentElement.dataset.blinkConfigured) return;
  document.documentElement.dataset.blinkConfigured = '1';
  const data = parse(dataNode.textContent, {});
  // Diagnostic events only. Never include engraving, contact data or cart properties.
  function publishCartEvent(stage, details) {
    try {
      const analytics = window.Shopify?.analytics;
      if (typeof analytics?.publish !== 'function') return;
      const result = analytics.publish(`blink:cart_add_${stage}`, { schema_version: 1, ...details });
      if (result && typeof result.catch === 'function') result.catch(() => {});
    } catch (_) { /* Telemetry must never interrupt a purchase. */ }
  }
  function cartErrorCode(error, validation) {
    const message = String(error?.message || '');
    if (validation) {
      if (message.includes('納期')) return 'delivery_consent';
      if (message.includes('付属ベルト')) return 'belt_required';
      if (message.includes('利き手')) return 'hand_required';
      if (message.includes('表面BLINKロゴ')) return 'logo_required';
      if (message.includes('名入れ')) return 'engraving_invalid';
      if (message.includes('カラー')) return 'variant_unavailable';
      if (message.includes('オプション') || message.includes('加工代')) return 'option_unavailable';
      if (message.includes('数量')) return 'quantity_invalid';
      return 'other_validation';
    }
    if (error?.name === 'AbortError') return 'timeout';
    if (message.includes('紐づけ') || message.includes('数量')) return 'cart_integrity';
    return 'request_or_availability';
  }
  const root = (data.root || '/').replace(/\/?$/, '/');
  const money = n => new Intl.NumberFormat('ja-JP', { style: 'currency', currency: data.currency || 'JPY', maximumFractionDigits: 0 }).format(Number(n) / 100);
  const esc = value => String(value ?? '').replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const $ = (selector, context = document) => context.querySelector(selector);
  const $$ = (selector, context = document) => Array.from(context.querySelectorAll(selector));
  const node = html => { const template = document.createElement('template'); template.innerHTML = html.trim(); return template.content.firstElementChild; };
  async function request(path, body) {
    const controller = new AbortController();
    const timer = setTimeout(() => controller.abort(), 20000);
    try {
      const response = await fetch(root + path, {
        method: body ? 'POST' : 'GET', credentials: 'same-origin', cache: 'no-store',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        ...(body ? { body: JSON.stringify(body) } : {}), signal: controller.signal
      });
      const result = await response.json();
      if (!response.ok) throw new Error(typeof result.description === 'string' ? result.description : '商品を追加できませんでした。選択内容を確認してください。');
      return result;
    } finally { clearTimeout(timer); }
  }
  const readCart = () => request('cart.js');
  const cartURL = () => root + 'cart';
  function imageURL(url, width = 180) { return url ? url + (url.includes('?') ? '&' : '?') + 'width=' + width : ''; }
  function publicProperties(line) {
    return Object.entries(props(line)).filter(([key, value]) => !key.startsWith('_') && value && key !== '製作番号')
      .map(([key, value]) => `<div><dt>${esc(key)}：</dt><dd>${esc(value)}</dd></div>`).join('');
  }
  async function removeConfiguration(cart, configuration) {
    const matches = (cart.items || []).filter(line => props(line)._blink_config === configuration);
    const parent = matches.find(line => props(line)._blink_role === 'case');
    if (parent) await request('cart/change.js', { id: parent.key, quantity: 0 });
    const remaining = await readCart();
    const orphaned = remaining.items.filter(line => props(line)._blink_config === configuration);
    if (orphaned.length) await request('cart/update.js', { updates: Object.fromEntries(orphaned.map(line => [line.key, 0])) });
    const verified = await readCart();
    if (verified.items.some(line => props(line)._blink_config === configuration)) throw new Error('カートの更新が完了していません。カートで内容をご確認ください。');
    return verified;
  }

  async function initCart() {
    const original = $('.cart__items');
    if (!original || !data.cart?.items?.length) return;
    const cart = await readCart();
    const groups = groupCart(cart);
    const wrapper = node('<div class="bc-cart"><p class="bc-note">シザーケースごとに仕様とオプションをご確認ください。</p><div class="bc-cart__list"></div><p class="bc-error" role="alert"></p></div>');
    const list = $('.bc-cart__list', wrapper);
    const error = $('.bc-error', wrapper);
    const lockCart = () => {
      wrapper.classList.add('bc-cart__loading');
      const dynamic = $('.cart__dynamic-checkout-buttons'); if (dynamic) dynamic.hidden = true;
      $$('[name="checkout"]').forEach(button => { button.disabled = true; });
    };
    groups.forEach(group => {
      const line = group.parent;
      const configured = props(line)._blink_role === 'case';
      const productURL = line.url || root + 'products/' + line.handle + '?variant=' + line.variant_id;
      const editURL = productURL + (productURL.includes('?') ? '&' : '?') + 'blink_edit=' + encodeURIComponent(props(line)._blink_config || '');
      const total = line.final_line_price + group.children.reduce((sum, child) => sum + child.final_line_price, 0);
      const card = node(`<article class="bc-cart__case"><div class="bc-cart__top">${line.image ? `<img src="${esc(imageURL(line.image))}" alt="${esc(line.product_title)}" width="96" height="112">` : ''}<div class="bc-cart__info">${configured ? `<span class="bc-cart__reference">製作番号 ${esc(props(line)['製作番号'])}</span>` : ''}<h2><a href="${esc(productURL)}">${esc(line.product_title)}</a></h2><div>${line.variant_title && line.variant_title !== 'Default Title' ? esc(line.variant_title) : ''}</div><dl>${publicProperties(line)}</dl><span>${money(line.final_line_price)}</span></div></div>${group.children.length ? `<div class="bc-cart__children"><p class="bc-note">このシザーケースのオプション</p>${group.children.map(child => `<div class="bc-cart__child"><span>${esc(child.product_title)}${child.variant_title && child.variant_title !== 'Default Title' ? '／' + esc(child.variant_title) : ''} × ${child.quantity}</span><span>${money(child.final_line_price)}</span></div>`).join('')}</div>` : ''}<p class="bc-cart__total">${configured ? 'このケースの合計 ' : '小計 '}${money(total)}</p><div class="bc-cart__controls"><div class="bc-quantity"><button type="button" data-minus aria-label="${esc(line.product_title)}の数量を減らす" ${line.quantity <= 1 ? 'disabled' : ''}>−</button><span aria-label="数量">${line.quantity}</span><button type="button" data-plus aria-label="${esc(line.product_title)}の数量を増やす">＋</button></div>${configured ? `<a class="bc-button bc-button--plain" href="${esc(editURL)}">仕様・オプションを変更</a>` : ''}<button data-remove class="bc-button bc-button--plain" type="button">${configured ? 'このケースを削除' : '削除'}</button></div>${checkGroup(group) ? '' : '<p class="bc-error">本体とオプションの構成が一致していません。「仕様・オプションを変更」から内容を確定してください。</p>'}</article>`);
      const changeQuantity = async quantity => {
        lockCart(); error.textContent = '';
        try {
          await request('cart/update.js', { updates: quantityUpdates(group, quantity) });
          const fresh = await readCart();
          const updated = groupCart(fresh).find(entry => entry.parent.key === line.key);
          if (updated && (!checkGroup(updated) || updated.parent.quantity !== quantity)) throw new Error('在庫などの理由で数量を変更できません。カートを再読み込みしてご確認ください。');
          location.reload();
        } catch (err) {
          error.textContent = err.message;
          $$('[name="checkout"]').forEach(button => { button.disabled = true; });
          error.append(node(`<a href="${cartURL()}"> カートを再読み込みする</a>`));
          wrapper.classList.remove('bc-cart__loading');
        }
      };
       $('[data-minus]', card).addEventListener('click', () => changeQuantity(line.quantity - 1));
      $('[data-plus]', card).addEventListener('click', () => changeQuantity(line.quantity + 1));
      $('[data-remove]', card).addEventListener('click', async () => {
        lockCart();
        try {
          if (configured) await removeConfiguration(await readCart(), props(line)._blink_config);
          else await request('cart/change.js', { id: line.key, quantity: 0 });
          location.reload();
        } catch (err) { error.textContent = err.message; wrapper.classList.remove('bc-cart__loading'); }
      });
      if (isNameEngraving(line) && !configured) {
        card.append(node(`<p class="bc-error">名入れ刻印は、対象のシザーケースの商品ページで文字を入力して追加してください。この単独の刻印商品を削除してからご注文ください。</p>`));
        card.append(node(`<a class="bc-button bc-button--plain" href="${root}pages/select">対応するシザーケースを選ぶ</a>`));
      }
      if (configured && props(line)['名入れ刻印'] && line.quantity > 1) {
        card.append(node('<p class="bc-note">この数量はすべて同じ刻印文字です。異なる文字をご希望の場合は、ケースを1点ずつ設定して追加してください。</p>'));
      }
      list.append(card);
    });
    const orphans = cart.items.filter(line => props(line)._blink_role === 'option' && !groups.some(group => group.children.includes(line)));
    orphans.forEach(line => {
      const item = node(`<article class="bc-cart__case"><p class="bc-error">${esc(line.product_title)}：対象のシザーケースが見つかりません。</p><button type="button" class="bc-button bc-button--plain">このオプションを削除</button></article>`);
      $('button', item).addEventListener('click', async () => { try { await request('cart/change.js', { id: line.key, quantity: 0 }); location.reload(); } catch (err) { error.textContent = err.message; } });
      list.append(item);
    });
    original.before(wrapper);
    document.body.classList.add('bc-cart-active');
    if (!checkCart(cart)) {
      error.textContent = '仕様が揃っていない商品があります。内容を変更するか、削除してからお進みください。';
      $$('[name="checkout"]').forEach(button => { button.disabled = true; });
      const dynamic = $('.cart__dynamic-checkout-buttons'); if (dynamic) dynamic.hidden = true;
    }
  }

  async function initProduct() {
    const product = data.product;
    const info = $('.product__info-container');
    const mainForm = $('product-form form[action*="/cart/add"]', info || document);
    if (!info || !mainForm || !product?.variants?.length) return;
    const requiredMessageJa = '現在の納期をご確認のうえ、チェックを入れてください。';
    const localizeConsentError = scope => {
      if (!document.documentElement.lang.toLowerCase().startsWith('ja') || !scope) return;
      const textNodes = [];
      if (scope.nodeType === Node.TEXT_NODE) textNodes.push(scope);
      else if (scope.nodeType === Node.ELEMENT_NODE || scope.nodeType === Node.DOCUMENT_FRAGMENT_NODE) {
        const walker = document.createTreeWalker(scope, NodeFilter.SHOW_TEXT);
        while (walker.nextNode()) textNodes.push(walker.currentNode);
      }
      textNodes.forEach(textNode => {
        if (textNode.nodeValue.trim() !== 'This is a required field') return;
        const optionRoot = textNode.parentElement?.closest('.po-option-root');
        if (optionRoot?.textContent.includes('現在の納期を確認し')) textNode.nodeValue = requiredMessageJa;
      });
    };
    const validationObserver = new MutationObserver(mutations => {
      mutations.forEach(mutation => {
        if (mutation.type === 'characterData') localizeConsentError(mutation.target);
        else mutation.addedNodes.forEach(localizeConsentError);
      });
    });
    validationObserver.observe(info, { childList: true, subtree: true, characterData: true });
    localizeConsentError(info);
    const options = (data.options || []).filter(item => item?.variants?.length);
    const lookup = id => [...options, nameEngraving].flatMap(item => item.variants.map(variant => ({ product: item, variant }))).find(item => Number(item.variant.id) === Number(id));
    const nameEngraving = data.nameEngraving?.variants?.length ? data.nameEngraving : { title: '名入れ刻印', variants: [] };
    const leftFee = options.find(item => item.handle === 'left-handed-fee');
    const custom = options.filter(item => item.handle !== 'left-handed-fee');
    let selected = [], busy = false, initialized = false, editLine = null;
    const editId = new URLSearchParams(location.search).get('blink_edit');
    const panel = node(`<section class="bc-panel" aria-label="カスタムオプションと合計"><button type="button" class="bc-banner" data-open><span class="bc-banner__art" aria-hidden="true"><img src="https://cdn.shopify.com/s/files/1/0697/5199/6495/files/blink-snap-studs-line.png?v=1789130086&width=240" alt="" width="72" height="64"><span>CUSTOM<br>OPTIONS</span></span><span class="bc-banner__body"><span class="bc-banner__kicker">CUSTOM OPTIONS</span><span class="bc-banner__title">シザーケースを<br>カスタムする</span><span class="bc-banner__description">金具・ステッチなどを変更できます</span><span class="bc-banner__cta" data-open-label>オプションを見る →</span></span></button><div class="bc-summary" aria-live="polite"></div><p class="bc-note">本体と選んだオプションをまとめてカートに追加します。</p><p class="bc-error" role="alert"></p></section>`);
    mainForm.after(panel);
    const summary = $('.bc-summary', panel), error = $('.bc-error', panel);
    const dialog = node(`<dialog class="bc-dialog" aria-labelledby="bc-dialog-title"><div class="bc-dialog__head"><h2 id="bc-dialog-title">カスタムオプション</h2><button class="bc-dialog__close" type="button" aria-label="選択を戻して閉じる">閉じる ×</button></div><form class="bc-dialog__body" id="bc-option-form"></form><div class="bc-dialog__foot"><div class="bc-price-row"><span>本体＋オプション</span><strong data-draft-total></strong></div><p class="bc-error" role="alert"></p><button class="bc-button bc-full" type="submit" form="bc-option-form">この内容で決定</button></div></dialog>`);
    document.body.append(dialog);
    const optionForm = $('form', dialog);
    const hideNativeEngraving = () => {
      const nativeInput = $$('.blink-engraving input[type="text"], input[placeholder="アルファベット10文字以内"]', info).find(input => input.id !== 'bc-name-engraving');
      const nativeRoot = nativeInput?.closest('.po-option-root') || nativeInput?.closest('.po-field-root') || nativeInput?.closest('.blink-engraving');
      if (nativeRoot) { nativeRoot.hidden = true; nativeRoot.style.setProperty('display', 'none', 'important'); }
    };
    hideNativeEngraving();
    let engravingValue = '', engravingEnabled = false;
    const engravingVariant = nameEngraving.variants.find(v => v.available);
    const engravingField = node(`<section class="bc-name-engraving bc-name-engraving--inline" aria-label="名入れ刻印"><fieldset class="bc-name-choice"><legend>名入れ刻印（任意）</legend><div class="bc-name-choice__items"><label><input type="radio" name="bc-name-choice" value="no" checked><span>刻印なし<small>追加0円</small></span></label><label><input type="radio" name="bc-name-choice" value="yes" ${engravingVariant ? '' : 'disabled'}><span>刻印あり${engravingVariant ? '' : '<small>現在ご利用いただけません</small>'}</span></label></div></fieldset><div class="bc-name-entry" hidden><p class="bc-name-engraving__price">＋${money(engravingVariant?.price || 0)}（税込）／1点</p><label for="bc-name-engraving">刻印する文字</label><input id="bc-name-engraving" class="bc-name-engraving__input" type="text" maxlength="10" autocomplete="off" autocapitalize="off" spellcheck="false" enterkeyhint="done" placeholder="例：Hareko（アルファベット10文字以内）" aria-describedby="bc-name-help bc-name-error bc-name-status" disabled><p id="bc-name-status" class="bc-name-status" role="status" aria-live="polite"></p><p id="bc-name-help" class="bc-note">大文字・小文字を組み合わせて10文字以内。シザーケースの裏面に刻印します。</p><p id="bc-name-error" class="bc-error" role="alert"></p></div></section>`);
    const engravingInput = $('#bc-name-engraving', engravingField);
    document.head.append(node('<style>.bc-name-engraving--inline{box-sizing:border-box;width:100%;padding:22px 0 0;margin:0;border-top:1px solid #d4d0c9}.bc-name-choice{border:0;padding:0;margin:0;min-width:0}.bc-name-choice legend{padding:0;margin-bottom:14px}.bc-name-choice__items{display:flex;gap:16px}.bc-name-choice__items label{display:flex;align-items:flex-start;gap:8px;flex:1;min-height:44px;cursor:pointer;line-height:1.5}.bc-name-choice__items input{appearance:auto;width:18px;height:18px;flex:0 0 18px;margin:4px 0 0;accent-color:#2d3831}.bc-name-choice__items small{display:block;font-size:.85em}.bc-name-entry[hidden]{display:none!important}.bc-name-entry>label{display:block;margin-top:12px}.bc-name-engraving__price{display:block;font-size:.9em;margin:14px 0 0}.bc-name-engraving__input{box-sizing:border-box;width:100%;min-height:48px;margin-top:8px;padding:10px 12px;border:1px solid #d4d0c9;background:#fff;font:inherit;color:inherit}.bc-name-engraving--inline .bc-note{margin:10px 0 0;line-height:1.8}.bc-name-engraving--inline .bc-error:empty,.bc-name-status:empty{display:none}.bc-name-status{margin:10px 0 0;padding:10px 12px;background:#edf3ee;color:#294638;border-radius:4px;font-size:.9em;line-height:1.6}.bc-name-engraving__input.is-confirmed{border-color:#4b6b54}</style>'));
    function setEngravingChoice(enabled) {
      engravingEnabled = !!enabled;
      $('.bc-name-entry', engravingField).hidden = !engravingEnabled;
      engravingInput.disabled = !engravingEnabled;
      $$('input[name="bc-name-choice"]', engravingField).forEach(input => { input.checked = input.value === (engravingEnabled ? 'yes' : 'no'); });
      if (!engravingEnabled) { engravingValue = ''; engravingInput.value = ''; }
      $('#bc-name-status', engravingField).textContent = '';
      $('#bc-name-error', engravingField).textContent = '';
      engravingInput.setAttribute('aria-invalid', 'false');
      engravingInput.classList.remove('is-confirmed');
    }
    $$('.bc-name-choice input', engravingField).forEach(input => input.addEventListener('change', () => {
      setEngravingChoice(input.value === 'yes');
      sync();
    }));
    engravingInput.addEventListener('input', () => {
      $('#bc-name-status', engravingField).textContent = '';
      engravingInput.classList.remove('is-confirmed');
      engravingValue = engravingInput.value.trim();
      const invalid = engravingValue && !validEngraving(engravingValue);
      $('#bc-name-error', engravingField).textContent = invalid ? 'アルファベットの大文字・小文字で10文字以内にしてください。' : '';
      engravingInput.setAttribute('aria-invalid', invalid ? 'true' : 'false');
      sync();
    });
    function confirmEngraving() {
      if (!engravingEnabled) return true;
      engravingValue = engravingInput.value.trim();
      const invalid = !validEngraving(engravingValue);
      $('#bc-name-error', engravingField).textContent = invalid ? 'アルファベットの大文字・小文字で10文字以内にしてください。' : '';
      engravingInput.setAttribute('aria-invalid', invalid ? 'true' : 'false');
      $('#bc-name-status', engravingField).textContent = invalid ? '' : engravingValue ? '✓ 刻印文字「' + engravingValue + '」で入力完了。変更する場合は入力欄をタップしてください。' : '名入れ刻印なし（追加料金なし）';
      engravingInput.classList.toggle('is-confirmed', !invalid && !!engravingValue);
      if (!invalid) engravingInput.value = engravingValue;
      sync();
      return !invalid;
    }
    engravingInput.addEventListener('keydown', event => {
      if (event.key !== 'Enter' || event.isComposing || event.keyCode === 229) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      if (confirmEngraving()) engravingInput.blur();
    });
    engravingInput.addEventListener('blur', confirmEngraving);
    custom.forEach(item => {
      const stitch = item.handle === 'stitch-color', studs = item.handle === 'custom-studs', engraving = item.handle === 'engraving', twoTone = item.handle === 'バイカラー-差し色-カスタム';
      const variant = item.variants[0];
      const needsNotes = studs || engraving || stitch || twoTone;
      const card = node(`<section class="bc-option" data-handle="${esc(item.handle)}"><div class="bc-option__title">${item.featured_image ? `<img src="${esc(imageURL(item.featured_image))}" alt="${esc(item.title)}" width="86" height="86" loading="lazy">` : ''}<div><h3>${esc(item.title)}</h3><p>${money(item.price_min || item.price)}${item.price_varies ? '〜' : ''}${studs ? '／1個' : ''}</p></div></div>${stitch ? `<label for="bc-${item.handle}">ステッチの色</label><select id="bc-${item.handle}" data-choice><option value="">変更しない（通常キャメル）</option>${item.variants.map(v => `<option value="${v.id}" ${v.available ? '' : 'disabled'}>${esc(v.title)} ＋${money(v.price)}${v.available ? '' : '（売り切れ）'}</option>`).join('')}</select>` : `<label class="bc-check"><input type="checkbox" data-choice value="${variant.id}" ${variant.available ? '' : 'disabled'}><span>${item.handle === 'hardware-color' ? 'シルバーの金具に変更する' : engraving ? 'オリジナル刻印を追加する（1箇所）' : twoTone ? 'バイカラーカスタムを追加する（差し色1色）' : 'スタッズを追加する'}${variant.available ? '' : '（売り切れ）'}</span></label>`}${needsNotes ? `<div class="bc-option__extra" hidden>${studs ? '<label>スタッズの個数<input type="number" data-quantity min="1" max="99" step="1" value="1"></label>' : ''}<p class="bc-note">${engraving ? '版の製作・刻印1箇所の料金です。ロゴデータ、位置、複数箇所への刻印は事前にご相談ください。' : studs ? '配置・デザインは事前にご相談ください。相談済みの個数を指定してください。' : twoTone ? '変更箇所と差し色は、ご注文前にLINEでご相談ください。' : 'その他のカラーは、ご注文前に色味をご相談ください。'}</p><label>${stitch ? '相談済みのカラー' : twoTone ? '相談済みの内容（変更箇所・革色）' : '相談済みの内容（デザイン・位置など）'}<textarea data-notes maxlength="160" rows="2"></textarea></label><label class="bc-check"><input type="checkbox" data-consulted><span>上記の内容を事前に相談済みです</span></label></div>` : ''}<details><summary>説明・写真を見る</summary>${item.description || ''}<div class="bc-gallery">${(item.images || []).slice(0,4).map(url => `<img src="${esc(imageURL(url,400))}" alt="${esc(item.title)}の参考写真" width="180" height="180" loading="lazy">`).join('')}</div><a href="${root}products/${esc(item.handle)}" target="_blank" rel="noopener">詳しい説明ページを開く ↗</a>${needsNotes ? `<p><a href="${root}pages/contact" target="_blank" rel="noopener">カスタムについて相談する ↗</a></p>` : ''}</details></section>`);
      const gallery = $('.bc-gallery', card);
      if (gallery && gallery.children.length > 1) {
        const images = $$('img', gallery);
        const hint = node(`<div class="bc-gallery-hint"><span data-gallery-count style="margin-left:auto">1 / ${images.length}</span></div>`);
        const frame = node('<div class="bc-gallery-frame"><button type="button" class="bc-gallery-prev" aria-label="前の画像">‹</button><button type="button" class="bc-gallery-next" aria-label="次の画像">›</button></div>');
        gallery.setAttribute('role', 'region');
        gallery.setAttribute('aria-label', item.title + 'の参考画像');
        gallery.before(hint, frame);
        frame.prepend(gallery);
        const previous = $('.bc-gallery-prev', frame), next = $('.bc-gallery-next', frame), counter = $('[data-gallery-count]', hint);
        let galleryFrame = 0;
        const updateGallery = () => {
          galleryFrame = 0;
          const position = gallery.scrollLeft;
          images.forEach((image, imageIndex) => {
            if (Math.abs(image.offsetLeft - position) < Math.abs(images[galleryFrame].offsetLeft - position)) galleryFrame = imageIndex;
          });
          counter.textContent = `${galleryFrame + 1} / ${images.length}`;
          previous.disabled = galleryFrame === 0;
          next.disabled = galleryFrame === images.length - 1;
        };
        const moveGallery = amount => {
          const destination = Math.max(0, Math.min(images.length - 1, galleryFrame + amount));
          gallery.scrollTo({ left: images[destination].offsetLeft, behavior: 'smooth' });
        };
        previous.addEventListener('click', () => moveGallery(-1));
        next.addEventListener('click', () => moveGallery(1));
        gallery.addEventListener('scroll', () => requestAnimationFrame(updateGallery), { passive: true });
        updateGallery();
      }
      if (stitch) {
        const select = $('[data-choice]', card);
        select.hidden = true; $('label[for="bc-stitch-color"]', card).hidden = true;
        const colors = { 'ダークブラウン': '#55372b', 'ブラック': '#292929', 'ダークネイビー': '#233247', 'ブルー': '#286083', 'デンマークグレー': '#8b8179', 'フォレスト': '#315849', 'オレンジ': '#dd652d' };
        const choices = [{ id: '', title: '変更しない', price: 0, available: true }, ...item.variants];
        const list = node(`<fieldset class="bc-stitch-list"><legend>ステッチの色・追加料金（税込）</legend>${choices.map(v => `<label class="bc-stitch-row"><input type="radio" name="bc-stitch-color" data-stitch-choice value="${v.id}" ${v.id === '' ? 'checked' : ''} ${v.available ? '' : 'disabled'}><span class="bc-stitch-swatch" aria-hidden="true" style="background:${colors[v.title] || (v.id === '' ? '#c49a66' : 'linear-gradient(135deg,#c49a66 0 33%,#315849 33% 66%,#286083 66%)')}"></span><span class="bc-stitch-name">${esc(v.title)}${v.id === '' ? '<small>通常キャメル</small>' : ''}${v.available ? '' : '<small>売り切れ</small>'}</span><span class="bc-stitch-price">${v.id === '' ? '追加 ￥0' : '＋' + money(v.price)}</span></label>`).join('')}<p class="bc-note">色見本は目安です。</p></fieldset>`);
        const picker = node('<details class="bc-stitch-picker"><summary><span class="bc-stitch-current"></span><span class="bc-stitch-chevron" aria-hidden="true">⌄</span></summary><div class="bc-stitch-scroll"></div></details>');
        select.after(picker); $('.bc-stitch-scroll', picker).append(list);
        const refreshChoice = () => { const row = $$('[data-stitch-choice]', list).find(input => input.value === select.value)?.closest('label'); if (row) $('.bc-stitch-current', picker).innerHTML = ['.bc-stitch-swatch', '.bc-stitch-name', '.bc-stitch-price'].map(selector => $(selector, row).outerHTML).join(''); picker.open = false; };
        select.addEventListener('bc-refresh', refreshChoice); refreshChoice();
        select.addEventListener('change', () => { refreshChoice(); $('summary', picker).focus(); });
        list.addEventListener('change', event => { if (event.target.matches('[data-stitch-choice]')) { select.value = event.target.value; select.dispatchEvent(new Event('change', { bubbles: true })); } });
      }
      optionForm.append(card);
    });
    const sticky = node('<div class="bc-sticky"><div class="bc-sticky__price"><small>本体＋オプション（税込）</small><strong></strong></div><button type="button" class="bc-button">この仕様でカートに追加</button></div>');
    document.body.append(sticky);
    document.body.classList.add('bc-active');
    const button = $('[name="add"]', mainForm);
    const variantNow = () => product.variants.find(v => Number(v.id) === Number($('[name="id"]', mainForm)?.value));
    const quantityNow = () => Math.max(1, Number(document.querySelector(`[name="quantity"][form="${mainForm.id}"]`)?.value || $('[name="quantity"]', mainForm)?.value || editLine?.quantity || 1));
    const roots = () => $$('.po-option-root', info);
    const rootFor = label => roots().find(item => ($('.po-label-label', item)?.textContent || '').replace(/\s*\*\s*$/, '').trim() === label);
    const selectedLabel = input => input.closest('label')?.querySelector('.po-optionItemLabel-label')?.textContent.trim() || input.closest('label')?.textContent.trim() || '';
    function specifications(validate = false) {
      const result = {};
      ['付属ベルト', '利き手', '表面BLINKロゴ'].forEach(label => {
        const section = rootFor(label);
        const checked = section && $('input:checked', section);
        if (validate && !checked) throw new Error(label + 'を選択してください。');
        if (checked) result[label] = selectedLabel(checked);
      });
      const name = engravingEnabled ? engravingValue.trim() : '';
      if (validate && engravingEnabled && !name) {
        $('#bc-name-error', engravingField).textContent = '刻印する文字を入力してください。刻印しない場合は「刻印なし」を選んでください。';
        engravingInput.setAttribute('aria-invalid', 'true');
        engravingInput.focus();
        const validationError = new Error('刻印する文字を入力してください。');
        validationError.handledInline = true;
        throw validationError;
      }
      if (name) {
        if (validate && !/^[A-Za-z]{1,10}$/.test(name)) { engravingInput.focus(); throw new Error('名入れ刻印はアルファベット10文字以内で入力してください。'); }
        result['名入れ刻印'] = name;
      }
      const consentRoot = roots().find(item => item.textContent.includes('現在の納期を確認し'));
      const consent = consentRoot && $('input[type="checkbox"]', consentRoot);
            let consentError = consentRoot && $('.bc-consent-error', consentRoot);
      if (validate && !consent?.checked) {
        if (consentRoot && !consentError) {
          consentError = node('<p class="bc-error bc-consent-error" id="bc-consent-error" role="alert"></p>');
          consentRoot.append(consentError);
        }
        if (consentError) consentError.textContent = requiredMessageJa;
        if (consent) consent.setAttribute('aria-describedby', 'bc-consent-error');
        consentRoot?.scrollIntoView({ block: 'center', behavior: 'smooth' });
        consent?.focus({ preventScroll: true });
        const validationError = new Error(requiredMessageJa);
        validationError.handledInline = true;
        throw validationError;
      }
            if (consent?.checked) {
        if (consentError) consentError.textContent = '';
        consent?.removeAttribute('aria-describedby');
        result['納期確認'] = '現在の納期を確認し、了承しました';
      }
      return result;
    }
    function allSelections(choices = selected, name = engravingValue) {
      const list = choices.map(item => ({ ...item }));
      if (engravingEnabled) {
        const variant = nameEngraving.variants.find(v => v.available);
        if (variant) list.push({ id: variant.id, quantity: 1 });
      }
      if ((specifications()['利き手'] || '').includes('左利き')) {
        const variant = leftFee?.variants.find(v => v.available);
        if (variant) list.push({ id: variant.id, quantity: 1 });
      }
      return list;
    }
    function titleFor(selection) {
      const found = lookup(selection.id); if (!found) return '';
      return found.product.title + (found.variant.title !== 'Default Title' ? '／' + found.variant.title : '') + (selection.quantity > 1 ? ' × ' + selection.quantity : '');
    }
    const total = (choices, name = engravingValue) => ((variantNow()?.price || 0) + allSelections(choices, name).reduce((sum, selection) => sum + (lookup(selection.id)?.variant.price || 0) * selection.quantity, 0)) * quantityNow();
    function sync() {
      const current = allSelections();
      const engravingSummary = engravingValue ? `<li><span>名入れ刻印</span><span>${esc(engravingValue)}</span></li>` : '';
      summary.innerHTML = `<ul><li><span>本体${quantityNow() > 1 ? ' × ' + quantityNow() : ''}</span><span>${money((variantNow()?.price || 0) * quantityNow())}</span></li>${current.map(selection => `<li><span>${esc(titleFor({ ...selection, quantity: selection.quantity * quantityNow() }))}</span><span>＋${money(lookup(selection.id).variant.price * selection.quantity * quantityNow())}</span></li>`).join('')}${engravingSummary}</ul><div class="bc-price-row"><span>合計（税込）</span><strong>${money(total(selected))}</strong></div>`;
      $('strong', sticky).textContent = money(total(selected));
      const optionCount = selected.length;
      $('[data-open-label]', panel).textContent = optionCount ? 'オプションを変更する（' + optionCount + '種類）' : 'オプションを見る →';
      const label = busy ? 'カートに反映しています…' : editId ? 'この仕様に変更してカートに戻る' : 'この仕様でカートに追加';
      const span = $('span', button); if (span) span.textContent = label;
      // Keep the product-page button clickable while consent is unchecked so our
      // Japanese inline validation can explain what the customer needs to do.
      button.disabled = busy || !initialized || !variantNow()?.available;
      $('button', sticky).textContent = label;
      $('button', sticky).disabled = busy || !initialized || !variantNow()?.available;
    }
    function readModal(validate = false) {
      return $$('.bc-option', dialog).flatMap(card => {
        const choice = $('[data-choice]', card);
        if (!choice) return [];
        const id = choice.tagName === 'SELECT' ? Number(choice.value) : choice.checked ? Number(choice.value) : 0;
        const found = lookup(id);
        const special = !!found && (card.dataset.handle === 'engraving' || card.dataset.handle === 'custom-studs' || card.dataset.handle === 'バイカラー-差し色-カスタム' || found.variant.title.includes('その他'));
        const extra = $('.bc-option__extra', card); if (extra) extra.hidden = !special;
        if (!id || !found) return [];
        const quantity = Number($('[data-quantity]', card)?.value || 1);
        const notes = special ? $('[data-notes]', card)?.value.trim() || '' : '';
        const consulted = !!$('[data-consulted]', card)?.checked;
        if (validate && (!Number.isSafeInteger(quantity) || quantity < 1 || quantity > 99)) throw new Error('スタッズの個数を1〜99で指定してください。');
        if (validate && special && (!notes || !consulted)) {
          extra?.scrollIntoView({ block: 'center' });
          throw new Error(found.product.title + '：相談済みの内容を入力し、確認欄にチェックしてください。');
        }
        return [{ id, quantity, ...(special ? { notes, consulted } : {}) }];
      });
    }
    function modalTotal() { $('[data-draft-total]', dialog).textContent = money(total(readModal(), engravingInput.value.trim())); }
    function openOptions() {
      hideNativeEngraving();
      $$('.bc-option', dialog).forEach(card => {
        const item = selected.find(selection => lookup(selection.id)?.product.handle === card.dataset.handle);
        const choice = $('[data-choice]', card);
        if (!choice) return;
        if (choice.tagName === 'SELECT') { choice.value = item ? String(item.id) : ''; $$('[data-stitch-choice]', card).forEach(input => { input.checked = input.value === choice.value; }); choice.dispatchEvent(new Event('bc-refresh')); }
        else choice.checked = !!item;
        const count = $('[data-quantity]', card); if (count) count.value = item?.quantity || 1;
        const notes = $('[data-notes]', card); if (notes) notes.value = item?.notes || '';
        const consulted = $('[data-consulted]', card); if (consulted) consulted.checked = !!item?.consulted;
      });
      $('.bc-error', dialog).textContent = '';
      modalTotal(); dialog.showModal();
    }
    $('[data-open]', panel).addEventListener('click', openOptions);
    $('.bc-dialog__close', dialog).addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', event => { if (event.target === dialog) { const r = dialog.getBoundingClientRect(); if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) dialog.close(); } });
    optionForm.addEventListener('input', event => {
      if (event.target.matches('[data-quantity], [data-notes]')) {
        const consulted = $('[data-consulted]', event.target.closest('.bc-option'));
        if (consulted) consulted.checked = false;
      }
      modalTotal();
    });
    optionForm.addEventListener('change', modalTotal);
    optionForm.addEventListener('submit', event => {
      event.preventDefault();
      try {
        selected = readModal(true);
        sync(); dialog.close(); error.textContent = '';
      }
      catch (err) { $('.bc-error', dialog).textContent = err.message; }
    });

    async function submit() {
      if (busy) return;
      const startedAt = performance.now();
      let attemptedVariant = null;
      try { attemptedVariant = variantNow(); } catch (_) { /* Do not alter purchase validation. */ }
      const eventBase = {
        product_id: String(product.id),
        variant_id: attemptedVariant ? String(attemptedVariant.id) : 'unselected',
        is_edit: Boolean(editId)
      };
      publishCartEvent('attempt', eventBase);
      error.textContent = '';
      let configuration = null, editRemovalStarted = false, inputValidated = false;
      try {
        if (!initialized) throw new Error('仕様の読み込み中です。少しお待ちください。');
        const spec = specifications(true), variant = variantNow(), quantity = quantityNow();
        if (!variant?.available) throw new Error('このカラーは現在ご購入いただけません。別のカラーを選択してください。');
        if (!Number.isSafeInteger(quantity) || quantity < 1 || quantity > 99) throw new Error('数量を1〜99で指定してください。');
        if (spec['利き手'].includes('左利き') && !leftFee?.variants.some(v => v.available)) throw new Error('左利き加工代を確認できません。お問い合わせください。');
        if (engravingEnabled && !nameEngraving.variants.some(v => v.available)) throw new Error('現在、名入れ刻印を追加できません。お問い合わせください。');
        const additions = allSelections();
        if (additions.some(item => !lookup(item.id)?.variant.available)) throw new Error('選択したオプションが売り切れです。選び直してください。');
        inputValidated = true;
        busy = true; sync(); button.setAttribute('aria-busy', 'true');
        const before = await readCart();
        if (editId && !before.items.some(line => props(line)._blink_role === 'case' && props(line)._blink_config === editId)) throw new Error('変更する商品がカートに見つかりません。カートから選び直してください。');
        configuration = crypto.randomUUID();
        const reference = 'B-' + configuration.slice(0,8).toUpperCase();
        const properties = {
          ...spec, '製作番号': reference,
          'カスタム（本体1点あたり）': additions.map(titleFor).join('／') || 'なし',
          '_blink_config': configuration, '_blink_role': 'case',
          ...(editId ? { '_blink_replaces': editId } : {}),
          '_blink_manifest': JSON.stringify(additions.map(item => ({ id: item.id, quantity: item.quantity }))),
          '_blink_selection': JSON.stringify(selected)
        };
        selected.filter(item => item.notes).forEach(item => { properties[lookup(item.id).product.title + 'の相談内容'] = item.notes; });
        // Add the unique parent first, then attach children to its exact line key.
        // This remains unambiguous when identical base variants are already in the cart.
        try { await request('cart/add.js', { items: [{ id: variant.id, quantity, properties }] }); }
        catch (err) {
          const recovered = await readCart();
          if (!recovered.items.some(line => props(line)._blink_config === configuration && props(line)._blink_role === 'case')) throw err;
        }
        let fresh = await readCart();
        const parent = fresh.items.find(line => props(line)._blink_config === configuration && props(line)._blink_role === 'case');
        if (!parent || parent.quantity !== quantity) throw new Error('本体の数量を確認できませんでした。もう一度お試しください。');
        if (additions.length) {
          const items = additions.map(item => ({
            id: item.id, quantity: item.quantity * quantity, parent_line_key: parent.key,
            properties: { '_blink_config': configuration, '_blink_role': 'option', '_blink_per_case': String(item.quantity),
              '製作番号': reference, '対象商品': product.title + '／' + variant.title,
              ...(Number(item.id) === NAME_VARIANT_ID ? { '名入れ刻印': engravingValue, '刻印位置': 'シザーケース裏面' } : {}),
              ...(item.notes ? { '相談済みの内容': item.notes } : {}) }
          }));
          try { await request('cart/add.js', { items }); }
          catch (err) {
            fresh = await readCart();
            const recovered = groupCart(fresh).find(group => props(group.parent)._blink_config === configuration);
            if (!recovered || !checkGroup(recovered)) throw err;
          }
        }
        fresh = await readCart();
        const group = groupCart(fresh).find(item => props(item.parent)._blink_config === configuration);
        if (!group || !checkGroup(group)) throw new Error('本体とオプションの紐づけを確認できませんでした。');
        if (editId) { editRemovalStarted = true; await removeConfiguration(fresh, editId); }
        publishCartEvent('success', {
          ...eventBase,
          elapsed_ms: Math.round(performance.now() - startedAt),
          option_count: additions.length
        });
        location.assign(cartURL());
      } catch (err) {
        const validation = !inputValidated;
        publishCartEvent(validation ? 'validation_error' : 'failure', {
          ...eventBase,
          elapsed_ms: Math.round(performance.now() - startedAt),
          error_code: cartErrorCode(err, validation)
        });
        if (editRemovalStarted) {
          error.textContent = '変更内容は保存されましたが、元の商品の削除を確認できません。カートで元の製作番号の商品を確認してください。';
          panel.append(node(`<a href="${cartURL()}">カートで変更内容を確認する</a>`));
          return;
        }
        if (configuration) {
          try { await removeConfiguration(await readCart(), configuration); }
          catch (_) { error.textContent = '通信の確認が必要です。再追加せず、カートで内容をご確認ください。'; panel.append(node(`<a href="${cartURL()}">カートを確認する</a>`)); busy = false; sync(); return; }
        }
                error.textContent = err.handledInline ? '' : err.name === 'AbortError' ? '通信に時間がかかっています。接続をご確認のうえ、もう一度お試しください。' : err.message;
                if (!err.handledInline) panel.scrollIntoView({ block: 'center', behavior: 'smooth' });
        busy = false; sync(); button.removeAttribute('aria-busy');
      }
    }
    // Capture at window level so Dawn and Easify do not separately add the same item.
    window.addEventListener('submit', event => { if (event.target === mainForm) { event.preventDefault(); event.stopImmediatePropagation(); submit(); } }, true);
    window.addEventListener('click', event => { if (event.target.closest('[name="add"]') === button) { event.preventDefault(); event.stopImmediatePropagation(); submit(); } }, true);
    $('button', sticky).addEventListener('click', submit);
    info.addEventListener('change', () => setTimeout(sync, 100));
    info.addEventListener('input', () => setTimeout(sync, 100));
    const priceNode = $('.price', info); if (priceNode) new MutationObserver(sync).observe(priceNode, { childList: true, subtree: true });
    const showSticky = () => sticky.classList.toggle('is-visible', window.scrollY > 360);
    window.addEventListener('scroll', showSticky, { passive: true }); showSticky();
    if (editId) {
      try {
        const cart = await readCart();
        editLine = cart.items.find(line => props(line)._blink_role === 'case' && props(line)._blink_config === editId);
        if (!editLine) throw new Error('変更対象の商品が見つかりません。カートから選び直してください。');
        selected = parse(props(editLine)._blink_selection, []).filter(item => lookup(item.id));
        panel.prepend(node(`<p class="bc-edit-notice">製作番号 ${esc(props(editLine)['製作番号'])} の仕様を変更しています。</p>`));
      } catch (err) { error.textContent = err.message; }
    }
    let attempts = 0;
    const readyTimer = setInterval(() => {
      attempts++;
      if (rootFor('付属ベルト') && rootFor('利き手') && rootFor('表面BLINKロゴ')) {
        clearInterval(readyTimer);
        hideNativeEngraving();
        rootFor('表面BLINKロゴ').after(engravingField);
        mainForm.after(panel);
        if (editLine) {
          ['付属ベルト', '利き手', '表面BLINKロゴ'].forEach(label => {
            const section = rootFor(label), desired = props(editLine)[label];
            const input = $$('input[type="checkbox"]', section).find(input => selectedLabel(input) === desired);
            if (input && !input.checked) input.click();
          });
          setEngravingChoice(!!props(editLine)['名入れ刻印']);
          engravingValue = props(editLine)['名入れ刻印'] || '';
          engravingInput.value = engravingValue;
          const quantity = document.querySelector(`[name="quantity"][form="${mainForm.id}"]`) || $('[name="quantity"]', mainForm);
          if (quantity) { quantity.value = editLine.quantity; quantity.dispatchEvent(new Event('change',{bubbles:true})); }
        }
        initialized = true; sync();
      } else if (attempts >= 60) {
        clearInterval(readyTimer); error.textContent = '仕様を読み込めませんでした。ページを再読み込みしてください。';
      }
    }, 250);
    sync();
  }
  if (data.page === 'cart') initCart().catch(() => {});
  else initProduct().catch(err => { console.error('BLINK purchase initialization:', err); });
})();
